export const Salutations = [
  { value: 'm', translationKey: 'general.salutation.m' },
  { value: 'w', translationKey: 'general.salutation.w' },
  { value: 'd', translationKey: 'general.salutation.d' },
];
